const { createContext } = require('react')
// context provider
const DispatchContext = createContext()

module.exports = DispatchContext
